namespace Cfnc {
    "use strict";

    interface ITestScoreScope extends ng.IScope {
        vm: TestScore;
        dateOptions: any;
    }

    interface ITestScore {
    }

    class TestScore implements ITestScore {
        static controllerId: string = "testScore";
        static $inject: Array<string> = ["$location", "common", "Restangular", "$scope", "$uibModal", "$http", "$document", "config", "helper"];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        pdfButtonDisable: boolean;
        emailButtonDisable: boolean;
        isSaving: boolean;
        templateUrl: string;
        satSubjectTests: any;
        testResults: any;
        testIDs: any;
        apExams: any;
        ibTests: any;
        total: any;
        maxDate: Date;
        minDate: Date;
        opened: boolean;
        accuplacerOpened: boolean;
        assetOpened: boolean;
        actOpened: boolean;
        actCheck: boolean;
        newActOpened: boolean;
        compassOpened: boolean;
        exploreOpened: boolean;
        psatOpened: boolean;
        satOpened: boolean;
        toeflOpened: boolean;
        workKeysOpened: boolean;
        gmatOpened: boolean;
        greOpened: boolean;
        lsatOpened: boolean;
        mcatOpened: boolean;
        hasScorePsat: any;
        hasScoreSat: any;
        hasScoreSatSubject: any;
        hasScoreExplore: any;
        hasScorePlan: any;
        hasScoreAct: any;
        hasScoreWorkKeys: any;
        hasScoreApExams: any;
        hasScoreToefl: any;
        hasScoreAccuplacer: any;
        hasScoreAsset: any;
        hasScoreCompass: any;
        hasScoreIbTests: any;
        hasScoreGre: any;
        hasScoreGmat: any;
        hasScoreLsat: any;
        hasScoreMcat: any;
        newActVersion: boolean;
        editActForm: boolean;
        actDateCheck: boolean;

        originalAccuplacer: any;
        originalAct: any;
        originalAsset: any;
        originalCompass: any;
        originalExplore: any;
        originalGmat: any;
        originalGre: any;
        originalLsat: any;
        originalMcat: any;
        originalPlan: any;
        originalPsat: any;
        originalSat: any;
        originalToefl: any;
        originalWorkkeys: any;

        psatTotal: number;
        planComposite: number;
        exploreComposite: number;

        editSatSubjectTests: any;
        editAPExams: any;
        editIBTests: any;

        constructor(private $location: ng.ILocationService,
            private common: ICommonFactory,
            private Restangular: Restangular.IService,
            private $scope: ITestScoreScope,
            private $uibModal: ng.ui.bootstrap.IModalService,
            private $http: any,
            private $document: ng.IDocumentService,
            private config: IConfig,
            private helper: IHelper) {

            this.log = common.logger.getLogFn(TestScore.controllerId);
            this.logError = common.logger.getLogFn(TestScore.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(TestScore.controllerId, "success");
            this.templateUrl = "psat";
            this.opened = false;
            this.editActForm = false;
            this.actDateCheck = false;
            this.maxDate = new Date();
            this.minDate = new Date(1899, 12);
            $scope.dateOptions = {
                showWeeks: false,
                maxDate: this.maxDate
            };

            this.satSubjectTests = [
                { code: "6", name: "Biology E (Ecological)" },
                { code: "7", name: "Biology M (Molecular)" },
                { code: "8", name: "Chemistry" },
                { code: "9", name: "Chinese with Listening" },
                { code: "10", name: "French" },
                { code: "11", name: "French with Listening" },
                { code: "12", name: "German" },
                { code: "13", name: "German with Listening" },
                { code: "14", name: "Italian" },
                { code: "15", name: "Japanese with Listening" },
                { code: "16", name: "Korean with Listening" },
                { code: "17", name: "Latin" },
                { code: "18", name: "Literature" },
                { code: "19", name: "Mathematics Level 1" },
                { code: "20", name: "Mathematics Level 2" },
                { code: "21", name: "Modern Hebrew" },
                { code: "22", name: "Physics" },
                { code: "23", name: "Spanish" },
                { code: "24", name: "Spanish with Listening" },
                { code: "25", name: "U.S. History" },
                { code: "26", name: "World History" }
            ]

            this.apExams = [
                { code: "39", name: "Biology" },
                { code: "40", name: "Calculus AB" },
                { code: "41", name: "Calculus BC" },
                { code: "8", name: "Chemistry" },
                { code: "42", name: "Chinese Language and Culture" },
                { code: "43", name: "Comparative Government and Politics" },
                { code: "44", name: "Computer Science A" },
                { code: "45", name: "Computer Science AB" },
                { code: "46", name: "English Language" },
                { code: "47", name: "English Literature" },
                { code: "48", name: "Environmental Science" },
                { code: "49", name: "European History" },
                { code: "50", name: "French Language" },
                { code: "51", name: "French Literature" },
                { code: "52", name: "German Language" },
                { code: "53", name: "Human Geography" },
                { code: "54", name: "Italian Language and Culture" },
                { code: "55", name: "Japanese Language and Culture" },
                { code: "56", name: "Latin Literature" },
                { code: "57", name: "Latin: Vergil" },
                { code: "58", name: "Macroeconomics" },
                { code: "59", name: "Microeconomics" },
                { code: "60", name: "Music Theory" },
                { code: "61", name: "Physics B" },
                { code: "62", name: "Physics C" },
                { code: "63", name: "Psychology" },
                { code: "64", name: "Spanish Language" },
                { code: "65", name: "Spanish Literature" },
                { code: "66", name: "Statistics" },
                { code: "67", name: "Studio Art" },
                { code: "68", name: "U.S. Government & Politics" },
                { code: "25", name: "U.S. History" },
                { code: "26", name: "World History" }
            ]

            this.ibTests = [
                { code: "77", name: "Anthropology" },
                { code: "78", name: "Social-Higher Level" },
                { code: "79", name: "Art-Higher Level" },
                { code: "80", name: "Biology-Higher Level" },
                { code: "81", name: "Chemistry-Higher Level" },
                { code: "82", name: "Computer Sci-Higher Level" },
                { code: "83", name: "Computer Sci-Subsidiary Level" },
                { code: "84", name: "Economics-Higher Level" },
                { code: "85", name: "English A1-Higher Level" },
                { code: "86", name: "English B-Higher Level" },
                { code: "87", name: "Environmental Sys-Higher Level" },
                { code: "88", name: "French A1-Higher Level" },
                { code: "89", name: "French A1-Subsidiary Level" },
                { code: "90", name: "French B-Higher Level" },
                { code: "91", name: "French B-Subsidiary Level" },
                { code: "92", name: "Pilot French B" },
                { code: "93", name: "German A1-Higher Level" },
                { code: "94", name: "German A1-Subsidiary Level" },
                { code: "95", name: "German B-Higher Level" },
                { code: "96", name: "German B-Subsidiary Level" },
                { code: "97", name: "History of the Islamic World" },
                { code: "98", name: "Info Tech in a Global Society" },
                { code: "99", name: "Language A2" },
                { code: "17", name: "Latin" },
                { code: "100", name: "Spanish A1-Higher Level" },
                { code: "101", name: "Spanish A1-Subsidiary Level" },
                { code: "102", name: "Spanish B-Higher Level" },
                { code: "103", name: "Spanish B-Subsidiary Level" },
                { code: "104", name: "Geography-Higher Level" },
                { code: "105", name: "History-Africa-Higher Level" },
                { code: "106", name: "History-Americas-Higher Level" },
                { code: "107", name: "History-Europe-Higher Level" },
                { code: "108", name: "History-E/SE Asia & Aust-Higher" },
                { code: "109", name: "History-W/S Asia-Higher Level" },
                { code: "110", name: "Management-Higher Level" },
                { code: "111", name: "Math-Higher Level" },
                { code: "112", name: "Advanced Mathematics" },
                { code: "113", name: "Mathematical Methods" },
                { code: "114", name: "Mathematical Studies" },
                { code: "115", name: "Music-Higher Level" },
                { code: "116", name: "Music-Subsidiary Level" },
                { code: "117", name: "Philosophy-Higher Level" },
                { code: "118", name: "Physics-Higher Level" },
                { code: "119", name: "Physics-Subsidiary Level" },
                { code: "120", name: "Psychology-Higher Level" },
                { code: "121", name: "Design Technology-Higher Level" },
                { code: "122", name: "Theatre Arts-Higher Level" },
                { code: "123", name: "Theatre Arts-Subsidiary Level" },
            ]

            this.testIDs = [
                { code: "1", name: "Accuplacer" },
                { code: "2", name: "ACT" },
                { code: "3", name: "AP Exams" },
                { code: "4", name: "Asset" },
                { code: "5", name: "Compass" },
                { code: "6", name: "EXPLORE" },
                { code: "7", name: "IB Tests" },
                { code: "8", name: "PLAN" },
                { code: "9", name: "PSAT" },
                { code: "10", name: "SAT" },
                { code: "11", name: "SAT Subject Tests" },
                { code: "12", name: "TOEFL" },
                { code: "13", name: "WorkKeys" },
                { code: "14", name: "GMAT" },
                { code: "15", name: "GRE" },
                { code: "16", name: "LSAT" },
                { code: "17", name: "MCAT" },
            ]

            this.activate();

        }

        activate() {
            var promises = [];
            this.common.activateController(promises, TestScore.controllerId)
                .then(() => {
                    this.log("Activated Test Scores View");
                    this.getTestScores();
                });
        }

        getTestScores() {
            this.Restangular.one("TestScores/getTestScores").get().then((results) => {
                this.testResults = results;
                this.hasScoreAccuplacer = results.accuplacer != null ? true : false;
                this.hasScoreAct = results.act != null ? true : false;
                this.hasScoreApExams = results.apExams.tests.length != 0 ? true : false;
                this.hasScoreAsset = results.asset != null ? true : false;
                this.hasScoreCompass = results.compass != null ? true : false;
                this.hasScoreExplore = results.explore != null ? true : false;
                this.hasScoreGmat = results.gmat != null ? true : false;
                this.hasScoreGre = results.gre != null ? true : false;
                this.hasScoreIbTests = results.ibTests.tests.length != 0 ? true : false;
                this.hasScoreLsat = results.lsat != null ? true : false;
                this.hasScoreMcat = results.mcat != null ? true : false;
                this.hasScorePlan = results.plan != null ? true : false;
                this.hasScorePsat = results.psat != null ? true : false;
                this.hasScoreSat = results.sat != null ? true : false;
                this.hasScoreSatSubject = results.satSubjectTests.tests.length != 0 ? true : false;
                this.hasScoreToefl = results.toefl != null ? true : false;
                this.hasScoreWorkKeys = results.workKeys != null ? true : false;

                this.originalAccuplacer = _.cloneDeep(this.testResults.accuplacer);
                this.originalAct = _.cloneDeep(results.act);
                this.originalAsset = _.cloneDeep(results.asset);
                this.originalCompass = _.cloneDeep(results.compass);
                this.originalExplore = _.cloneDeep(results.explore);
                this.originalGmat = _.cloneDeep(results.gmat);
                this.originalGre = _.cloneDeep(results.gre);
                this.originalLsat = _.cloneDeep(results.lsat);
                this.originalMcat = _.cloneDeep(results.mcat);
                this.originalPlan = _.cloneDeep(results.plan);
                this.originalPsat = _.cloneDeep(results.psat);
                this.originalSat = _.cloneDeep(results.sat);
                this.originalToefl = _.cloneDeep(results.toefl);
                this.originalWorkkeys = _.cloneDeep(results.workKeys);
                this.editAPExams = _.cloneDeep(results.apExams.tests);
                this.editSatSubjectTests = _.cloneDeep(results.satSubjectTests.tests);
                this.editIBTests = _.cloneDeep(results.ibTests.tests);
                this.checkSatValues();
                this.checkACTValues();
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
                });
        }

        createNewItem = (arrayToExpand: any): void => {
            var newItem: any = {
                id: 0,
                testName: "",
                scoreID: "",
                score: "",
                date: "",
                editMode: true
            };
            arrayToExpand.unshift(newItem);
        };

        cancelTestAccuplacer(test: any, originalTest: any) {
            this.testResults.accuplacer = _.cloneDeep(this.originalAccuplacer);
        }

        cancelTestAct(test: any, originalTest: any) {
            this.testResults.act = _.cloneDeep(this.originalAct);
        }

        cancelTestAsset(test: any, originalTest: any) {
            this.testResults.asset = _.cloneDeep(this.originalAsset);
        }

        cancelTestCompass(test: any, originalTest: any) {
            this.testResults.compass = _.cloneDeep(this.originalCompass);
        }

        cancelTestExplore(test: any, originalTest: any) {
            this.testResults.explore = _.cloneDeep(this.originalExplore);
        }

        cancelTestPlan(test: any, originalTest: any) {
            this.testResults.plan = _.cloneDeep(this.originalPlan);
        }

        cancelTestPsat(test: any, originalTest: any) {
            this.testResults.psat = _.cloneDeep(this.originalPsat);
        }

        cancelTestSat(test: any, originalTest: any) {
            this.testResults.sat = _.cloneDeep(this.originalSat);
        }

        cancelTestToefl(test: any, originalTest: any) {
            this.testResults.toefl = _.cloneDeep(this.originalToefl);
        }

        cancelTestWorkKeys(test: any, originalTest: any) {
            this.fixTestDate(this.originalWorkkeys);
            console.log(this.testResults.workKeys);
            console.log(this.originalWorkkeys);
            this.testResults.workKeys = _.cloneDeep(this.originalWorkkeys);
        }

        cancelTestGmat(test: any, originalTest: any) {
            this.testResults.gmat = _.cloneDeep(this.originalGmat);
        }

        cancelTestGre(test: any, originalTest: any) {
            this.testResults.gre = _.cloneDeep(this.originalGre);
        }

        cancelTestLsat(test: any, originalTest: any) {
            this.testResults.lsat = _.cloneDeep(this.originalLsat);
        }

        cancelTestMcat(test: any, originalTest: any) {
            this.testResults.mcat = _.cloneDeep(this.originalMcat);
        }

        cancelTestEdit(test: any, originalTest: any) {
            console.log("did you even run this function?");
            console.log(test);
            console.log(originalTest);
            test = _.cloneDeep(originalTest);
            test = ng.copy(originalTest);
        }

        cancelEditIBTests = (itemToRemove: any, index: any): void => {
            console.log(itemToRemove);
            console.log(index);
            if (itemToRemove.id != 0) {
                var originalName = this.testResults.ibTests.tests[index];
                itemToRemove.editMode = false;
                itemToRemove.name = originalName;

            } else {
                this.editIBTests.splice(index, 1);
            };
        };

        checkSatValues() {
            if (this.hasScorePsat) {
                this.psatTotal = Number(this.testResults.psat.reading) + Number(this.testResults.psat.math) + Number(this.testResults.psat.writing);
            }
            if (this.hasScoreSat)
                this.testResults.sat.composite = Number(this.testResults.sat.reading) + Number(this.testResults.sat.math) + Number(this.testResults.sat.writing);
        }

        checkACTValues() {
            if (this.hasScoreAct) {
                this.testResults.act.composite = Math.round(((Number(this.testResults.act.english) + Number(this.testResults.act.math) + Number(this.testResults.act.reading) + Number(this.testResults.act.science)) / 4));
                this.checkActDate();
            }
            if (this.hasScoreExplore)
                this.exploreComposite = Math.round(((Number(this.testResults.explore.english) + Number(this.testResults.explore.math) + Number(this.testResults.explore.reading) + Number(this.testResults.explore.science)) / 4));
            if (this.hasScorePlan)
                this.planComposite = Math.round(((Number(this.testResults.plan.english) + Number(this.testResults.plan.math) + Number(this.testResults.plan.reading) + Number(this.testResults.plan.science)) / 4));
        }

        checkActDate() {
            this.newActVersion = moment(this.testResults.act.date).isAfter(moment('2015-08-31 23:59:59'));
        }

        cancelEdit = (editArray: any, originalArray: any, itemToRemove: any, index: any): void => {
            if (itemToRemove.id != 0) {
                var originalName = _.cloneDeep(originalArray[index]);
                itemToRemove.editMode = false;
                itemToRemove.score = originalName.score;
                itemToRemove.date = moment(originalName.date).toDate();
                itemToRemove = _.cloneDeep(originalName);

            } else {
                editArray.splice(index, 1);
            };
        };

        fixTestDate(editTest: any) {
            editTest.date = moment(editTest.date).toDate();
        }

        removeFromList(listObject: any, index: any) {
            listObject.splice(index, 1);
        }

        saveAccuplacer() {
            this.testResults.accuplacer.readingComp = this.testResults.accuplacer.readingComp != null ? this.testResults.accuplacer.readingComp.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.accuplacer.sentenceSkills = this.testResults.accuplacer.sentenceSkills != null ? this.testResults.accuplacer.sentenceSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.accuplacer.arithmetic = this.testResults.accuplacer.arithmetic != null ? this.testResults.accuplacer.arithmetic.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.accuplacer.elemAlgebra = this.testResults.accuplacer.elemAlgebra != null ? this.testResults.accuplacer.elemAlgebra.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                ReadingComp: this.testResults.accuplacer.readingComp,
                SentenceSkills: this.testResults.accuplacer.sentenceSkills,
                Arithmetic: this.testResults.accuplacer.arithmetic,
                ElemAlgebra: this.testResults.accuplacer.elemAlgebra,
                Date: this.testResults.accuplacer.date
            }
            this.Restangular.all("TestScores/AddAccuplacer").post(test).then((results) => {
                this.originalAccuplacer = _.cloneDeep(this.testResults.accuplacer);
                this.logSuccess("Accuplacer scores saved.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveACT() {
            this.checkACTValues();
            this.testResults.act.english = this.testResults.act.english != null ? this.testResults.act.english.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.mechanics = this.testResults.act.mechanics != null ? this.testResults.act.mechanics.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.rhetoricalSkills = this.testResults.act.rhetoricalSkills != null ? this.testResults.act.rhetoricalSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.math = this.testResults.act.math != null ? this.testResults.act.math.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.reading = this.testResults.act.reading != null ? this.testResults.act.reading.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.science = this.testResults.act.science != null ? this.testResults.act.science.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.preAlgebra = this.testResults.act.preAlgebra != null ? this.testResults.act.preAlgebra.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.intermediateAlgebra = this.testResults.act.intermediateAlgebra != null ? this.testResults.act.intermediateAlgebra.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.planGeometry = this.testResults.act.planGeometry != null ? this.testResults.act.planGeometry.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.socialStudies = this.testResults.act.socialStudies != null ? this.testResults.act.socialStudies.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.artsLit = this.testResults.act.artsLit != null ? this.testResults.act.artsLit.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.englishWriting = this.testResults.act.englishWriting != null ? this.testResults.act.englishWriting.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.writing = this.testResults.act.writing != null ? this.testResults.act.writing.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.prepareHighMath != null ? this.testResults.act.prepareHighMath.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.numberQuantity != null ? this.testResults.act.numberQuantity.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.functions != null ? this.testResults.act.functions.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.integratingSkills != null ? this.testResults.act.integratingSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.modeling != null ? this.testResults.act.modeling.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.dataInterpretation != null ? this.testResults.act.dataInterpretation.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.scientificInvestigation != null ? this.testResults.act.scientificInvestigation.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.modelEvaluation != null ? this.testResults.act.modelEvaluation.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.writingProduction != null ? this.testResults.act.writingProduction.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.languageKnowledge != null ? this.testResults.act.languageKnowledge.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.englishConventions != null ? this.testResults.act.englishConventions.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.keyIdeasDetails != null ? this.testResults.act.keyIdeasDetails.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.craftStructure != null ? this.testResults.act.craftStructure.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.integratingKnowledge != null ? this.testResults.act.integratingKnowledge.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.understandingComplexTexts != null ? this.testResults.act.understandingComplexTexts.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.ideasAnalysis != null ? this.testResults.act.ideasAnalysis.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.developmentSupport != null ? this.testResults.act.developmentSupport.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.organization != null ? this.testResults.act.organization.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.languageConventions != null ? this.testResults.act.languageConventions.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.geometry != null ? this.testResults.act.geometry.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.algebra != null ? this.testResults.act.algebra.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.act.statistics != null ? this.testResults.act.statistics.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                English: this.testResults.act.english,
                Mechanics: this.testResults.act.mechanics,
                RhetoricalSkills: this.testResults.act.rhetoricalSkills,
                Math: this.testResults.act.math,
                Reading: this.testResults.act.reading,
                Science: this.testResults.act.science,
                PreAlgebra: this.testResults.act.preAlgebra,
                Geometry: this.testResults.act.geometry,
                IntermediateAlgebra: this.testResults.act.intermediateAlgebra,
                PlanGeometry: this.testResults.act.planGeometry,
                SocialStudies: this.testResults.act.socialStudies,
                ArtsLit: this.testResults.act.artsLit,
                EnglishWriting: this.testResults.act.englishWriting,
                Writing: this.testResults.act.writing,
                PrepareHighMath: this.testResults.act.prepareHighMath,
                NumberQuantity: this.testResults.act.numberQuantity,
                Functions: this.testResults.act.functions,
                IntegratingSkills: this.testResults.act.integratingSkills,
                Modeling: this.testResults.act.modeling,
                DataInterpretation: this.testResults.act.dataInterpretation,
                ScientificInvestigation: this.testResults.act.scientificInvestigation,
                ModelEvaluation: this.testResults.act.modelEvaluation,
                WritingProduction: this.testResults.act.writingProduction,
                LanguageKnowledge: this.testResults.act.languageKnowledge,
                EnglishConventions: this.testResults.act.englishConventions,
                KeyIdeasDetails: this.testResults.act.keyIdeasDetails,
                CraftStructure: this.testResults.act.craftStructure,
                IntegratingKnowledge: this.testResults.act.integratingKnowledge,
                UnderstandingComplexTexts: this.testResults.act.understandingComplexTexts,
                IdeasAnalysis: this.testResults.act.ideasAnalysis,
                DevelopmentSupport: this.testResults.act.developmentSupport,
                Organization: this.testResults.act.organization,
                LanguageConventions: this.testResults.act.languageConventions,
                Algebra: this.testResults.act.algebra,
                Statistics: this.testResults.act.statistics,
                Composite: this.testResults.act.composite,
                Date: this.testResults.act.date
            }
            this.Restangular.all("TestScores/AddACT").post(test).then((results) => {
                this.checkACTValues();
                this.originalAct = _.cloneDeep(this.testResults.act);
                this.logSuccess("ACT scores saved.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        addTestToList(testType: any, scoreList: any, originalList: any, editList: any, newTest: any, index: any) {
            var newTestIndex = _.findIndex(scoreList, { 'code': newTest.scoreID });
            var found = _.findIndex(scoreList, ['scoreID', newTest.scoreID]);
            if (found == -1) {
                editList[index].testName = scoreList[newTestIndex].name;
                this.saveListTest(testType, newTest);
                newTest.editMode = false;
                originalList = _.cloneDeep(editList);
            }
            else {
                this.logError("Test is already in the list", "", true);
            }
        }

        saveListTest(testID: any, newTest: any) {
            newTest.score = newTest.score.replace(/^0+(?!\.|$)/, '');
            var test = {
                Id: newTest.id,
                TestID: testID,
                ScoreID: parseInt(newTest.scoreID),
                Score: newTest.score,
                Date: newTest.date
            }
            this.Restangular.all("TestScores/AddListTest").post(test).then((results) => {
                this.logSuccess("Test saved.", "", true);
                newTest.id = results;
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveAsset() {
            this.testResults.asset.writingSkills = this.testResults.asset.writingSkills != null ? this.testResults.asset.writingSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.asset.readingSkills = this.testResults.asset.readingSkills != null ? this.testResults.asset.readingSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.asset.numericalSkills = this.testResults.asset.numericalSkills != null ? this.testResults.asset.numericalSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.asset.elemAlgebra = this.testResults.asset.elemAlgebra != null ? this.testResults.asset.elemAlgebra.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                WritingSkills: this.testResults.asset.writingSkills,
                ReadingSkills: this.testResults.asset.readingSkills,
                NumericalSkills: this.testResults.asset.numericalSkills,
                ElemAlgebra: this.testResults.asset.elemAlgebra,
                Date: this.testResults.asset.date
            }
            this.Restangular.all("TestScores/AddAsset").post(test).then((results) => {
                this.originalAsset = _.cloneDeep(this.testResults.asset);
                this.logSuccess("Asset scores saved.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveCompass() {
            this.testResults.compass.writingSkills = this.testResults.compass.writingSkills != null ? this.testResults.compass.writingSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.compass.readingSkills = this.testResults.compass.readingSkills != null ? this.testResults.compass.readingSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.compass.numericalSkills = this.testResults.compass.numericalSkills != null ? this.testResults.compass.numericalSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.compass.algebra = this.testResults.compass.algebra != null ? this.testResults.compass.algebra.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.compass.collegeAlgebra = this.testResults.compass.collegeAlgebra != null ? this.testResults.compass.collegeAlgebra.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.compass.geometry = this.testResults.compass.geometry != null ? this.testResults.compass.geometry.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.compass.trigonometry = this.testResults.compass.trigonometry != null ? this.testResults.compass.trigonometry.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                WritingSkills: this.testResults.compass.writingSkills,
                ReadingSkills: this.testResults.compass.readingSkills,
                NumericalSkills: this.testResults.compass.numericalSkills,
                Algebra: this.testResults.compass.algebra,
                CollegeAlgebra: this.testResults.compass.collegeAlgebra,
                Geometry: this.testResults.compass.geometry,
                Trigonometry: this.testResults.compass.trigonometry,
                Date: this.testResults.compass.date
            }
            this.Restangular.all("TestScores/AddCompass").post(test).then((results) => {
                this.originalCompass = _.cloneDeep(this.testResults.compass);
                this.logSuccess("Compass scores saved.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveExplore() {
            this.testResults.explore.english = this.testResults.explore.english != null ? this.testResults.explore.english.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.explore.mechanics = this.testResults.explore.mechanics != null ? this.testResults.explore.mechanics.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.explore.rhetoricalSkills = this.testResults.explore.rhetoricalSkills != null ? this.testResults.explore.rhetoricalSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.explore.math = this.testResults.explore.math != null ? this.testResults.explore.math.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.explore.reading = this.testResults.explore.reading != null ? this.testResults.explore.reading.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.explore.science = this.testResults.explore.science != null ? this.testResults.explore.science.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                English: this.testResults.explore.english,
                Mechanics: this.testResults.explore.mechanics,
                RhetoricalSkills: this.testResults.explore.rhetoricalSkills,
                Math: this.testResults.explore.math,
                Reading: this.testResults.explore.reading,
                Science: this.testResults.explore.science,
                Date: this.testResults.explore.date
            }
            this.Restangular.all("TestScores/AddExplore").post(test).then((results) => {
                this.checkACTValues();
                this.logSuccess("Explore scores saved.", "", true);
                this.originalExplore = _.cloneDeep(this.testResults.explore);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        savePlan() {
            this.testResults.plan.english = this.testResults.plan.english != null ? this.testResults.plan.english.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.mechanics = this.testResults.plan.mechanics != null ? this.testResults.plan.mechanics.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.rhetoricalSkills = this.testResults.plan.rhetoricalSkills != null ? this.testResults.plan.rhetoricalSkills.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.math = this.testResults.plan.math != null ? this.testResults.plan.math.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.reading = this.testResults.plan.reading != null ? this.testResults.plan.reading.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.science = this.testResults.plan.science != null ? this.testResults.plan.science.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.preAlgebra = this.testResults.plan.preAlgebra != null ? this.testResults.plan.preAlgebra.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.plan.geometry = this.testResults.plan.geometry != null ? this.testResults.plan.geometry.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                English: this.testResults.plan.english,
                Mechanics: this.testResults.plan.mechanics,
                RhetoricalSkills: this.testResults.plan.rhetoricalSkills,
                Math: this.testResults.plan.math,
                Reading: this.testResults.plan.reading,
                Science: this.testResults.plan.science,
                PreAlgebra: this.testResults.plan.preAlgebra,
                Geometry: this.testResults.plan.geometry,
                Date: this.testResults.plan.date
            }
            this.Restangular.all("TestScores/AddPlan").post(test).then((results) => {
                this.checkACTValues();
                this.logSuccess("Plan scores saved.", "", true);
                this.originalPlan = _.cloneDeep(this.testResults.plan);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        savePSAT() {
            this.testResults.psat.reading = this.testResults.psat.reading != null ? this.testResults.psat.reading.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.psat.math = this.testResults.psat.math != null ? this.testResults.psat.math.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.psat.writing = this.testResults.psat.writing != null ? this.testResults.psat.writing.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                Reading: this.testResults.psat.reading,
                Math: this.testResults.psat.math,
                Writing: this.testResults.psat.writing,
                Date: this.testResults.psat.date
            }
            this.Restangular.all("TestScores/AddPSAT").post(test).then((results) => {
                this.logSuccess("PSAT scores saved.", "", true);
                this.originalPsat = _.cloneDeep(this.testResults.psat);
                this.psatTotal = Number(this.testResults.sat.reading) + Number(this.testResults.sat.math) + Number(this.testResults.sat.writing);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveSAT() {
            this.checkSatValues();
            this.testResults.sat.reading = this.testResults.sat.reading != null ? this.testResults.sat.reading.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.sat.math = this.testResults.sat.math != null ? this.testResults.sat.math.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.sat.writing = this.testResults.sat.writing != null ? this.testResults.sat.writing.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                Reading: this.testResults.sat.reading,
                Math: this.testResults.sat.math,
                Writing: this.testResults.sat.writing,
                Composite: this.testResults.sat.composite,
                Date: this.testResults.sat.date
            }
            this.Restangular.all("TestScores/AddSAT").post(test).then((results) => {
                this.logSuccess("SAT scores saved.", "", true);
                this.originalSat = _.cloneDeep(this.testResults.sat);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveTOEFL() {
            this.testResults.toefl.ibtTotal = this.testResults.toefl.ibtTotal != null ? this.testResults.toefl.ibtTotal.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.ibtListening = this.testResults.toefl.ibtListening != null ? this.testResults.toefl.ibtListening.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.ibtReading = this.testResults.toefl.ibtReading != null ? this.testResults.toefl.ibtReading.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.ibtSpeaking = this.testResults.toefl.ibtSpeaking != null ? this.testResults.toefl.ibtSpeaking.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.ibtWriting = this.testResults.toefl.ibtWriting != null ? this.testResults.toefl.ibtWriting.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.pbtTotal = this.testResults.toefl.pbtTotal != null ? this.testResults.toefl.pbtTotal.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.pbtListeningComp = this.testResults.toefl.pbtListeningComp != null ? this.testResults.toefl.pbtListeningComp.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.pbtWritten = this.testResults.toefl.pbtWritten != null ? this.testResults.toefl.pbtWritten.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.toefl.pbtReadingComp = this.testResults.toefl.pbtReadingComp != null ? this.testResults.toefl.pbtReadingComp.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                IBTTotal: this.testResults.toefl.ibtTotal,
                IBTListening: this.testResults.toefl.ibtListening,
                IBTReading: this.testResults.toefl.ibtReading,
                IBTSpeaking: this.testResults.toefl.ibtSpeaking,
                IBTWriting: this.testResults.toefl.ibtWriting,
                PBTTotal: this.testResults.toefl.pbtTotal,
                PBTListeningComp: this.testResults.toefl.pbtListeningComp,
                PBTWritten: this.testResults.toefl.pbtWritten,
                PBTReadingComp: this.testResults.toefl.pbtReadingComp,
                Date: this.testResults.toefl.date
            }
            this.Restangular.all("TestScores/AddTOEFL").post(test).then((results) => {
                this.logSuccess("TOEFL scores saved.", "", true);
                this.originalToefl = _.cloneDeep(this.testResults.toefl);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveWorkKeys() {
            this.testResults.workKeys.appMath = this.testResults.workKeys.appMath != null ? this.testResults.workKeys.appMath.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.workKeys.appMathScale = this.testResults.workKeys.appMathScale != null ? this.testResults.workKeys.appMathScale.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.workKeys.locatingInfo = this.testResults.workKeys.locatingInfo != null ? this.testResults.workKeys.locatingInfo.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.workKeys.locatingInfoScale = this.testResults.workKeys.locatingInfoScale != null ? this.testResults.workKeys.locatingInfoScale.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.workKeys.readingInfo = this.testResults.workKeys.readingInfo != null ? this.testResults.workKeys.readingInfo.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.workKeys.readingInfoScale = this.testResults.workKeys.readingInfoScale != null ? this.testResults.workKeys.readingInfoScale.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                AppMath: this.testResults.workKeys.appMath,
                AppMathScale: this.testResults.workKeys.appMathScale,
                LocatingInfo: this.testResults.workKeys.locatingInfo,
                LocatingInfoScale: this.testResults.workKeys.locatingInfoScale,
                ReadingInfo: this.testResults.workKeys.readingInfo,
                ReadingInfoScale: this.testResults.workKeys.readingInfoScale,
                Date: this.testResults.workKeys.date
            }
            this.Restangular.all("TestScores/AddWorkKeys").post(test).then((results) => {
                this.logSuccess("WorkKeys scores saved.", "", true);
                this.originalWorkkeys = _.cloneDeep(this.testResults.workKeys);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveGMAT() {
            this.testResults.gmat.total = this.testResults.gmat.total != null ? this.testResults.gmat.total.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.gmat.quantitative = this.testResults.gmat.quantitative != null ? this.testResults.gmat.quantitative.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.gmat.analytical = this.testResults.gmat.analytical != null ? this.testResults.gmat.analytical.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.gmat.verbal = this.testResults.gmat.verbal != null ? this.testResults.gmat.verbal.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                Total: this.testResults.gmat.total,
                Quantitative: this.testResults.gmat.quantitative,
                Analytical: this.testResults.gmat.analytical,
                Verbal: this.testResults.gmat.verbal,
                Date: this.testResults.gmat.date
            }
            this.Restangular.all("TestScores/AddGMAT").post(test).then((results) => {
                this.logSuccess("GMAT scores saved.", "", true);
                this.originalGmat = _.cloneDeep(this.testResults.gmat);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveGRE() {
            this.testResults.gre.verbalReasoning = this.testResults.gre.verbalReasoning != null ? this.testResults.gre.verbalReasoning.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.gre.quanReasoning = this.testResults.gre.quanReasoning != null ? this.testResults.gre.quanReasoning.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.gre.analyticalWriting = this.testResults.gre.analyticalWriting != null ? this.testResults.gre.analyticalWriting.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                VerbalReasoning: this.testResults.gre.verbalReasoning,
                QuanReasoning: this.testResults.gre.quanReasoning,
                AnalyticalWriting: this.testResults.gre.analyticalWriting,
                Date: this.testResults.gre.date
            }
            this.Restangular.all("TestScores/AddGRE").post(test).then((results) => {
                this.logSuccess("GRE scores saved.", "", true);
                this.originalGre = _.cloneDeep(this.testResults.gre);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveLSAT() {
            this.testResults.lsat.score = this.testResults.lsat.score != null ? this.testResults.lsat.score.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                Score: this.testResults.lsat.score,
                Date: this.testResults.lsat.date
            }
            this.Restangular.all("TestScores/AddLSAT").post(test).then((results) => {
                this.logSuccess("LSAT scores saved.", "", true);
                this.originalLsat = _.cloneDeep(this.testResults.lsat);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveMCAT() {
            this.testResults.mcat.total = this.testResults.mcat.total != null ? this.testResults.mcat.total.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.mcat.physicalScience = this.testResults.mcat.physicalScience != null ? this.testResults.mcat.physicalScience.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.mcat.biologicalScience = this.testResults.mcat.biologicalScience != null ? this.testResults.mcat.biologicalScience.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.mcat.verbalReasoning = this.testResults.mcat.verbalReasoning != null ? this.testResults.mcat.verbalReasoning.replace(/^0+(?!\.|$)/, '') : null;
            this.testResults.mcat.writingSample = this.testResults.mcat.writingSample != null ? this.testResults.mcat.writingSample.replace(/^0+(?!\.|$)/, '') : null;
            var test = {
                Total: this.testResults.mcat.total,
                PhysicalScience: this.testResults.mcat.physicalScience,
                BiologicalScience: this.testResults.mcat.biologicalScience,
                VerbalReasoning: this.testResults.mcat.verbalReasoning,
                WritingSample: this.testResults.mcat.writingSample,
                Date: this.testResults.mcat.date
            }
            this.Restangular.all("TestScores/AddMCAT").post(test).then((results) => {
                this.originalMcat = _.cloneDeep(this.testResults.mcat);
                this.logSuccess("MCAT scores saved.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        removeTest(testId: any) {
            switch (testId)
            {
                case 1:
                    this.testResults.accuplacer = null;
                    this.hasScoreAccuplacer = false;
                    break;
                case 2:
                    this.testResults.act = null;
                    this.hasScoreAct = false;
                    break;
                case 4:
                    this.testResults.asset = null;
                    this.hasScoreAsset = false;
                    break;
                case 5:
                    this.testResults.compass = null;
                    this.hasScoreCompass = false;
                    break;
                case 6:
                    this.testResults.explore = null;
                    this.hasScoreExplore = false;
                    break;
                case 8:
                    this.testResults.plan = null;
                    this.hasScorePlan = false;
                    break;
                case 9:
                    this.testResults.psat = null;
                    this.hasScorePsat = false;
                    break;
                case 10:
                    this.testResults.sat = null;
                    this.hasScoreSat = false;
                    break;
                case 12:
                    this.testResults.toefl = null;
                    this.hasScoreToefl = false;
                    break;
                case 13:
                    this.testResults.workKeys = null;
                    this.hasScoreWorkKeys = false;
                    break;
                case 14:
                    this.testResults.gmat = null;
                    this.hasScoreGmat = false;
                    break;
                case 15:
                    this.testResults.gre = null;
                    this.hasScoreGre = false;
                    break;
                case 16:
                    this.testResults.lsat = null;
                    this.hasScoreLsat = false;
                    break;
                case 17:
                    this.testResults.mcat = null;
                    this.hasScoreMcat = false;
                    break;
            }
        }

        deleteTest(testId: number, scoreId: any, test: any, hasTestValue: boolean) {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/testScores/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    var testModel = { TestID: testId, ScoreID: scoreId };
                    this.Restangular.all("TestScores/deleteTestScore").post(testModel).then((results) => {
                        this.removeTest(testId);
                        this.logSuccess('Test Deleted', '', true);
                    }, (reason) => {
                        console.error(reason);
                        this.logError(reason, reason, true);
                    });
                }
            });
        }

        deleteListTest(testId: number, scoreId: any, hasTestValue: boolean, editList: any, originalList: any, index: number) {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/testScores/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    var testModel = { TestID: testId, ScoreID: scoreId };
                    this.Restangular.all("TestScores/deleteTestScore").post(testModel).then((results) => {
                        this.removeFromList(editList, index);
                        originalList = _.cloneDeep(editList);
                        if(editList.length == 0)
                            hasTestValue = false;
                        this.logSuccess('Test Deleted', '', true);
                    }, (reason) => {
                        console.error(reason);
                        this.logError(reason, reason, true);
                    });
                }
            });
        }

        print = ($event) => {
            this.pdfButtonDisable = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html><head>" + headHtml + "</head><body style='margin: 50px; background-color: #fff; background-image:none'>" + $event.currentTarget.parentElement.parentElement.innerHTML + "</body></html>";
            this.helper.openFile(this.config.apiHost + "/pdf/download", { html: encodeURIComponent(html), url: location.origin }).then(() => {
                this.pdfButtonDisable = false;
            });

        };

        email = ($event) => {
            this.emailButtonDisable = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html>" + headHtml + "<body style='margin: 50px; background-color: #fff; background-image:none'>" + $event.currentTarget.parentElement.parentElement.innerHTML + "</body></html>";
            this.Restangular.all("pdf").all("email").post({ html: encodeURIComponent(html), url: location.origin })
                .then((response) => {
                    this.emailButtonDisable = false;
                    this.logSuccess("Email has been sent to the email address associated with your CFNC profile.", "Email has been sent to the email address associated with your CFNC profile.", true);
                }, (reason) => {
                    console.log(reason);
                    this.logError("There was a problem sending your email. Please try again later.", reason, true);
                }, (state) => {
                });
        }

       
    }

    angular.module("app").controller(TestScore.controllerId, TestScore);
}